<div *ngIf='componentReady' class='MenuButton'>
  <button [matMenuTriggerFor]='mainMenu' aria-label='Example icon-button with a menu' mat-icon-button>
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #mainMenu='matMenu' [backdropClass]="'full-width'">
    <ng-container *ngFor='let item of properties.items'>
      <button (click)='item.onClick && item.onClick.call(null, target)' *ngIf='item.type === buttonTypes.BUTTON'
              [class]='item.class'
              [disabled]='item.disabled'
              mat-menu-item>
        <span>{{ item.label }}</span>
      </button>
      <button *ngIf='item.type === buttonTypes.LINK' [class]='item.class' [routerLink]='item.route' mat-menu-item>
        <span>{{ item.label }}</span>
      </button>
    </ng-container>
  </mat-menu>
</div>